import { InningModel } from "./Inning";
import { TeamScoreModel } from "./TeamScore";

export class LinescoreModel{
    public awayTeam: TeamScoreModel = new TeamScoreModel();
    public homeTeam: TeamScoreModel = new TeamScoreModel();
    public innings: InningModel[] = [];
    public diamondText:string = '';

    public balls:number = 0;
    public strikes:number = 0;
    public outs:number = 0;

    public inningArrow:string = 'top';
    public inningCurrent:number = 1;

    public get inningsToShow():InningModel[] {
        const innings:InningModel[] = [];
        let index =  (this.inningCurrent - 9) <= 0 ? 0 : (this.inningCurrent - 9);
        for(let i = 0; i < 9; i++){
            const inning =  ( (index + 1) > this.innings.length) ? new InningModel() : this.innings[index];
            innings.push(inning);
            index++;
        }
        return innings;
    }

    public get inningNumbersToShow():number[] {
        let startInning =  (this.inningCurrent - 9) <= 0 ? 1 : (this.inningCurrent - 8);
        const innings:number[] = [];
        for(let i = 0; i < 9; i++){
            innings.push(startInning++);
        }
        return innings;
    }

    public get isTop(): boolean {
        return  this.inningArrow.toLowerCase() !== 'bottom';
    }

    public get topBottomText(): string {
        if(this.isTop){
            if(this.outs < 3){
                return 'Alta';
            } else {
                return 'Mitad';
            }
        } else {
            if(this.outs < 3){
                return 'Baja';
            } else {
                return 'Cierre';
            }
        }
    }

    public get inningPositionText(): string {
        const positions = [
            'era',
            'da',
            'era',
            'ta',
            'ta',
            'ta',
            'ma',
            'ava',
            'ena',
            'ma'
        ];
        let n =  this.inningCurrent + '';
        let nN = parseInt(this.inningCurrent + '');
        let lastNumber = parseInt((n.length > 1 ? n.substring(1) : n));
        lastNumber = lastNumber === 0 ? 10 : lastNumber; 
        return nN > 10 ? 'ava' : positions[lastNumber - 1];
    };

    constructor(obj?: any) {
        if (obj) {
            this.diamondText = obj.diamond;
            this.balls = parseInt(obj.balls.replace('balls-', ''));
            this.strikes = parseInt(obj.strikes.replace('strikes-', ''));
            this.outs = parseInt(obj.outs.replace('outs-', ''));
            this.inningArrow = obj.inningArrow;
            this.inningCurrent = obj.inningCurrent;

            this.awayTeam.abbrName = obj.awayTeam;
            this.awayTeam.shortName = obj.awayTeamShort;
            this.awayTeam.wins = obj.awayTeamWins;
            this.awayTeam.losses = obj.awayTeamLosses;
            this.awayTeam.homes = obj.awayHomes;
            this.awayTeam.runs = obj.awayRuns;
            this.awayTeam.errors = obj.awayErrors;

            this.homeTeam.abbrName = obj.homeTeam;
            this.homeTeam.shortName = obj.homeTeamShort;
            this.homeTeam.wins = obj.homeTeamWins;
            this.homeTeam.losses = obj.homeTeamLosses;
            this.homeTeam.homes = obj.homeHomes;
            this.homeTeam.runs = obj.homeRuns;
            this.homeTeam.errors = obj.homeErrors;

            this.innings = obj.scores.map((r: any) => new InningModel(r));
        }
    }
}